import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BuyerDto } from "../models/buyer/buyer.dto";
import { GenericResponseDto } from "../models/generic-response.dto";

/**
 * Service for retrieving Client Portal buyers shown on the Sales Portal Buyer screen.
 */
@Injectable({
  providedIn: "root",
})
export class BuyerListingService {
  private readonly _http = inject(HttpClient);
  private readonly _buyerBaseUrl = environment.baseUrl + "/Buyer";

  /**
   * Retrieves all active Client Portal Buyer-role users for authorized clients.
   * @returns Observable of the buyer response, including `totalRecords`.
   */
  getBuyers(): Observable<GenericResponseDto<BuyerDto[]>> {
    return this._http.get<GenericResponseDto<BuyerDto[]>>(
      this._buyerBaseUrl + "/GetBuyers"
    );
  }
}
